<div>
    <vl-form-message-label for="sortDropDown">Sorteer</vl-form-message-label>
    <vl-select name="sortDropDown" v-model="currentSortedColumnKey" class="kl-card-sort__select">
        <option v-for="(column) in columns" :value="column.key">{{column.label}}</option>
    </vl-select>
    <vl-button
        @click="toggleColumnSortOrder"
        :icon="currentSortedColumnIcon"
        mod-icon
        mod-tertiary
        class="kl-card-sort__direction-button"
    />
</div>

